<div class="womens-health-section section-wrapper">
	<div id="medical-women-health">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.medical-history.women-health.heading'">Women's Health</span>
		</div>
		<div
			tabindex="0"
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.have-concerns'">
			Do you have concerns in any of the following women's health areas?
		</div>
		<div class="checkbox-list" *ngFor="let concern of healthConcernsLookup">
			<mat-checkbox
				[disabled]="readOnly"
				appAutofocus
				(change)="healthConcernSelection($event, concern)"
				[checked]="concern.checked"
				>{{ concern.name }}</mat-checkbox
			>
			<mat-form-field appearance="fill" *ngIf="concern.id === womenHealthEnum.OTHER && showOtherTextBox">
				<mat-label
					><span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.other-concerns'"
						>Women's Health Concerns</span
					></mat-label
				>
				<textarea
					matInput
					cdkTextareaAutosize
					cdkAutosizeMinRows="1"
					cdkAutosizeMaxRows="4"
					[formControl]="otherConcerns"></textarea>
			</mat-form-field>
		</div>
		<div class="women-health-fields" [formGroup]="womenHealthForm">
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.first-mensuration-age'">
				At what age did you begin menstruation?
			</div>
			<div>
				<mat-form-field appearance="fill">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.medical-history.women-health.form-fields.first-menstrual-cycle'
							"
							>Age of first menstrual cycle</span
						></mat-label
					>
					<input matInput formControlName="menstruationOnsetAge" [readOnly]="readOnly" />
				</mat-form-field>
			</div>
			<div>
				<mat-form-field appearance="fill">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.medical-history.women-health.form-fields.last-menstrual-cycle'
							"
							>Date of last menstrual cycle</span
						></mat-label
					>
					<input matInput formControlName="lastMenstrualCycle" [readOnly]="readOnly" [imask]="dateMask.iMaskArgs" />
				</mat-form-field>
			</div>
			<div>
				<mat-form-field appearance="fill">
					<mat-label
						><span
							[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.age-of-child-birth'"
							>Your age at first childbirth (If applicable)</span
						></mat-label
					>
					<input matInput formControlName="ageWhenFirstDelivery" [readOnly]="readOnly" />
				</mat-form-field>
			</div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.how-many-partners'">
				How many sexual partners have you had in the past year?
			</div>
			<div>
				<mat-form-field appearance="fill">
					<mat-label
						><span
							[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.no-of-partners'"
							>Sexual partners</span
						></mat-label
					>
					<input matInput formControlName="noOfSexualPartners" [readOnly]="readOnly" />
				</mat-form-field>
			</div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.currently-pregnant'">
				Are you currently pregnant or have you been pregnant within the last 12 months?
			</div>
			<div>
				<mat-radio-group formControlName="currentlyPregnant">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="with-bg-wrapper">
				<div class="with-bg">
					<div
						class="radio-btn-label"
						[translate]="
							'wellness.health-assessment-new.medical-history.women-health.form-fields.perform-self-breast-exam'
						">
						Do you perform a monthly breast self-exam?
					</div>
					<div>
						<mat-radio-group formControlName="performSelfExam">
							<mat-radio-button [value]="true">
								<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-yes'"
									>Yes</span
								>
							</mat-radio-button>
							<mat-radio-button [value]="false">
								<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-no'"
									>No</span
								>
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
			</div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.entered-menopause'">
				Have you entered menopause?
			</div>
			<div>
				<mat-radio-group formControlName="inMenopause">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="with-bg-wrapper">
				<div class="with-bg">
					<div
						class="radio-btn-label"
						[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.sexually-active'">
						Are you currently sexually active or have you ever been?
					</div>
					<div>
						<mat-radio-group formControlName="sexuallyActive">
							<mat-radio-button [value]="true">
								<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-yes'"
									>Yes</span
								>
							</mat-radio-button>
							<mat-radio-button [value]="false">
								<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-no'"
									>No</span
								>
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
			</div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.had-std'">
				Have you ever had a sexually transmitted disease (STD)?
			</div>
			<div>
				<mat-radio-group formControlName="hadStd">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<ng-container *ngIf="womenHealthForm.get('hadStd').value">
				<mat-form-field class="text-field" appearance="fill">
					<mat-label
						><span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.std-details'"
							>STD details</span
						></mat-label
					>
					<textarea
						class="text-area"
						matInput
						cdkTextareaAutosize
						cdkAutosizeMinRows="1"
						cdkAutosizeMaxRows="3"
						formControlName="stdDetails"></textarea>
				</mat-form-field>
			</ng-container>
			<div class="with-bg-wrapper">
				<div class="with-bg">
					<div
						class="radio-btn-label"
						[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.like-to-be-tested'">
						Would you like to be tested for STDs (HIV, Gonorrhea, Syphilis, Chlamydia?)
					</div>
					<div>
						<mat-radio-group formControlName="wantToTestForStd">
							<mat-radio-button [value]="true">
								<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-yes'"
									>Yes</span
								>
							</mat-radio-button>
							<mat-radio-button [value]="false">
								<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-no'"
									>No</span
								>
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
			</div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.had-sex-with'">
				Do you have or have you had sex with
			</div>
			<div>
				<mat-radio-group formControlName="sexualOption">
					<mat-radio-button [value]="'Men'">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-men'"
							>Men</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="'Women'">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-women'"
							>Women</span
						>
					</mat-radio-button>
					<mat-radio-button class="padding-right" [value]="'Both'">
						<span [translate]="'wellness.health-assessment-new.medical-history.women-health.form-fields.option-both'"
							>Both</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button
		class="button button-medium"
		mat-button
		appEheAnalytics
		[data]="{
			pageUrl: '/ha/new/(medical:women-health)',
			redirectedTo: '/ha/new/(medical:family-history)',
			componentName: 'WomensHealth',
			id: 'HA Medical Info - Womens Health',
			placement: 'ha women health screen'
		}">
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
